import React, { createContext, useContext, ReactNode } from 'react';
import { useTelegram, TelegramUser, TelegramWebApp } from './useTelegram';

interface TelegramContextType {
    tg: TelegramWebApp | null;
    user: TelegramUser | null;
    isTelegram: boolean;
    isReady: boolean;
    initData: string | null;
    showAlert: (message: string) => void;
    showConfirm: (message: string) => Promise<boolean>;
    closeApp: () => void;
}

const TelegramContext = createContext<TelegramContextType | undefined>(undefined);

export function TelegramProvider({ children }: { children: ReactNode }) {
    const telegram = useTelegram();

    return (
        <TelegramContext.Provider value={telegram}>
            {children}
        </TelegramContext.Provider>
    );
}

export function useTelegramContext() {
    const context = useContext(TelegramContext);
    if (context === undefined) {
        throw new Error('useTelegramContext must be used within a TelegramProvider');
    }
    return context;
}